<template>
  <section class="dp-layout">

    <section class="dp-left">
      <DepartmentPane directory-scope="teaching" @tree-node-click="treeNodeClick"></DepartmentPane>
    </section>


    <section class="dp-right">
      <!--工具条-->
      <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>

      <!--列表-->
      <div class="tbl-scroll-host">
      <el-table :data="users" v-loading="listLoading" @select="dialogCheck" @row-click="selectCurrentRow" ref="table"
        height="100%" style="width: 100%" class="custom-tbl">
        <el-table-column type="selection" width="50"></el-table-column>
        <!-- <el-table-column type="index" width="80"></el-table-column> -->
        <el-table-column prop="UserName" label="姓名" width></el-table-column>
        <el-table-column prop="DeptName" label="部门" width></el-table-column>

        <el-table-column prop="KaoqinDate" label="日期" width></el-table-column>

        <el-table-column prop="Time" label="刷卡时间" width></el-table-column>


        <el-table-column prop="DailyKaoqinStatus" label="状态" width></el-table-column>
        <!-- <el-table-column prop="DailyWorkSeconds" label="学时" width></el-table-column> -->
        <el-table-column fixed="right" label="操作" width="80">
          <template slot-scope="scope">
            <el-button @click="showHistory(scope.row)" type="text">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      </div>

      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="10" :total="total"
          style="float: right"></el-pagination>
      </el-col>

      <el-dialog :title="historyDataTitle" :visible.sync="dialogVisible" width="40%" center
        @close="historyDataHandleClose">
        <el-table :data="historyData" class="custom-tbl" style="width: 100%">
          <el-table-column property="Time" label="时间"></el-table-column>
          <el-table-column property="KqTerminalId" label="终端编码"></el-table-column>
          <el-table-column property="KqTerminalName" label="终端名称"></el-table-column>
          <el-table-column property="TouchType" label="刷卡类型"></el-table-column>
        </el-table>

        <el-col :span="24" class="toolbar">
          <el-pagination layout="total, prev, pager, next, jumper" @current-change="handleHistoryDataChange" :page-size="10"
            :total="historyDataTotal" style="float: right"></el-pagination>
        </el-col>

        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
        </div>
      </el-dialog>

    </section>

  </section>
</template>

<script>
import util from "../../../util/date";
import { getDeptSchoolBusRecords, getetSchoolBusRecords, exportDeptSchoolBusRecords } from '../../api/modules/misc';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from '../../components/DepartmentPane'

export default {
  components: { Toolbar, DepartmentPane },
  data() {
    return {
      filters: {
      },
      searchList: [
        {
          label: '日期',
          key: 'date',
          type: 'date'
        },
      ],
      buttonList: [],
      options: [],
      users: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
      statusList: [
        { name: "激活", value: true },
        { name: "禁用", value: false },
      ],
      total: 0,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列
      currentRow: null,
      isResouceShow: 0,
      DepartmentId: "",
      dialogVisible: false,
      currentDate: "",
      historyData: [],
      historyDataTitle: "",
      historyDataTotal: 0,
      historyDataPage: 1,
      historyUserId: 0
    };
  },
  computed: {
  },
  methods: {

    getStatusColor(status) {
      if (status != "normal") {
        return 'red';
      }
      return '';
    },
    treeNodeClick(data, node, component) {
      this.DepartmentId = data.value
      this.handleQuery();
    },

    dialogCheck(selection, row) {
      this.currentRow = null;
      this.$refs.table.clearSelection();
      if (selection.length === 0) {
        return;
      }
      if (row) {
        this.selectCurrentRow(row);
      }
    },
    selectCurrentRow(val) {
      if (val) {
        this.currentRow = val;
        this.$refs.table.clearSelection();
        this.$refs.table.toggleRowSelection(val, true);
      }
    },
    callFunction(item) {
      this.currentDate = item.search.date || "";
      if (typeof item.search == 'object') {
        this.filters = item.search
      } else {
        this.filters = {
          key: item.search,
        }
      }
      this[item.Func].apply(this, item)
    },
    handleCurrentChange(val) {
      this.page = val;
      this.handleQuery();
    },
    //获取用户列表
    handleQuery() {
      let _this = this;
      let para = {
        page: this.page,
        departmentId: this.DepartmentId,
        ...this.filters,
      };
      this.listLoading = true;
      //NProgress.start();
      getDeptSchoolBusRecords(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.users = res.data.response.data;
        this.listLoading = false;
        //NProgress.done();
      });
    },

    handleHistoryDataChange(val) {
      this.historyDataPage = val;
      this.handleHistoryDataQuery();
    },

    handleHistoryDataQuery() {
      let para = {
        page: this.historyDataPage,
        departmentId: this.DepartmentId,
        startDate: this.currentDate,
        userAccountUid: this.historyUserId
      };
      getetSchoolBusRecords(para).then((res) => {
        this.historyDataTotal = res.data.response.dataCount;
        this.historyData = res.data.response.data;

        this.$nextTick(() => { this.dialogVisible = true; })

      });
    },

    showHistory(row) {
      this.currentDate = row.KaoqinDate;
      this.historyUserId = row.UserId;
      this.historyDataTitle = "【" + row.UserName + "】" + row.KaoqinDate + "刷卡明细";
      this.handleHistoryDataQuery();
    },

    historyDataHandleClose() {
      this.historyData = [];
      this.historyDataTotal = 0;
      this.historyDataPage = 1;
    },

    async exportExcel() {
      try {
        let para = {
          page: this.page,
          departmentId: this.DepartmentId,
          ...this.filters,
        };

        var fileName = "校车班级考勤报表";
        const response = await exportDeptSchoolBusRecords(para);
        if (!response.data) {
          this.$message({
            message: "导出数据为空",
            type: "error",
          });
          return;
        }
        // 处理导出数据        
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName + '.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      } catch (error) {
        console.error('下载失败:', error);
      }
    },

  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}

</style>
